document.addEventListener('click', function(e) {
  const btn = e.target.closest('.quick-add-plus');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  // Get product handle from the nearest product link
  const card = btn.closest('product-card');
  if (!card) return;

  const productLink = card.querySelector('a[href*="/products/"]');
  if (!productLink) return;

  const match = productLink.getAttribute('href').match(/\/products\/([^?#/]+)/);
  if (!match) return;

  const productHandle = match[1];

  // Find the native quick-add modal trigger if it exists
  const nativeBtn = card.querySelector('quick-add-modal button, [id^="quick-add-"] button');
  if (nativeBtn) {
    nativeBtn.click();
    return;
  }

  // Fallback: fetch product section and inject into modal
  btn.classList.add('loading');

  fetch(`/products/${productHandle}?section_id=main-product`)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Try to find existing modal in the page
      let modal = document.querySelector('quick-add-modal');

      if (!modal) {
        // Create a minimal modal wrapper if none exists
        modal = document.createElement('quick-add-modal');
        modal.innerHTML = `
          <div role="dialog" aria-modal="true" class="quick-add-modal">
            <div class="quick-add-modal__content" id="quick-add-modal-content"></div>
          </div>`;
        document.body.appendChild(modal);
      }

      const modalContent = modal.querySelector('.quick-add-modal__content, #quick-add-modal-content');
      const fetchedContent = doc.querySelector('.product-information, #MainProduct-main-product, main');

      if (modalContent && fetchedContent) {
        modalContent.innerHTML = fetchedContent.innerHTML;
      }

      // Open the modal
      if (typeof modal.show === 'function') {
        modal.show(btn);
      } else {
        modal.removeAttribute('hidden');
        modal.setAttribute('open', '');
      }
    })
    .catch(err => console.error('Quick Add failed:', err))
    .finally(() => btn.classList.remove('loading'));
});
